export default __webpack_public_path__ + "static/media/icon1.b6ad973e.svg";